import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { SectionHeading } from "@/components/Section";
import ReportingDashboard from "@/components/ReportingDashboard";
import { Reveal } from "@/components/Reveal";

export default function ReportingSection() {
  return (
    <section data-testid="dashboard-mockups" className="py-24 md:py-32 bg-cream">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-12">
          <SectionHeading
            chapter="05 / Invoices & Reporting"
            overline="Purchasing Intelligence"
            title={<>All your orders, invoices &amp; purchasing data in one place</>}
            lead="Stop searching through messages and paper invoices. Your complete purchasing history stays organized in one secure account — with downloadable PDFs and exportable reports."
          />
          <Reveal delay={0.1}>
            <Link to="/reporting" data-testid="see-platform-btn" className="group inline-flex items-center gap-2 rounded-full border border-forest px-6 py-3 text-sm font-semibold text-forest hover:bg-forest hover:text-butter transition-colors duration-300 whitespace-nowrap">
              See How the Platform Works <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Reveal>
        </div>

        <div className="rounded-3xl bg-sage/40 border border-forest/15 p-4 md:p-8">
          <ReportingDashboard />
        </div>

        <Reveal className="mt-6 flex items-center justify-center gap-2 text-sm text-forest/60">
          <ShieldCheck className="h-4 w-4" /> Secure customer data handling · downloadable PDF invoices · exportable reports
        </Reveal>
      </div>
    </section>
  );
}
